import type { Tile } from '../game/types.js';
import { TILE_LONG, TILE_SHORT } from '../utils/constants.js';
import type { RenderPalette } from './palette.js';
import { drawTileFace, type TileRect } from './TileRenderer.js';

/**
 * Floating tile that follows the pointer during a drag. Drawn in screen
 * space (on top of racks + board), centered on `centerScreen` and tinted
 * green when over a legal drop target.
 */
export function drawDragGhost(
  ctx: CanvasRenderingContext2D,
  tile: Tile,
  centerScreen: { readonly x: number; readonly y: number },
  palette: RenderPalette,
  validDrop: boolean,
): void {
  // Vertical orientation matches the south rack's tile orientation so the
  // ghost stays continuous with where it was picked up.
  const rect: TileRect = {
    x: centerScreen.x - TILE_SHORT / 2,
    y: centerScreen.y - TILE_LONG / 2,
    long: TILE_LONG,
    short: TILE_SHORT,
    orientation: 'vertical',
  };
  ctx.save();
  ctx.shadowColor = 'rgba(0, 0, 0, 0.55)';
  ctx.shadowBlur = 14;
  ctx.shadowOffsetY = 6;
  drawTileFace(ctx, rect, tile[0], tile[1], palette, { selected: validDrop });
  ctx.restore();
}
